import React from "react";

import Login from "./views/Auth/Login";
import TrocarSenha from "./views/Auth/TrocarSenha";
import Dashboard from "./views/Home/Dashboard";
import MapaEntradaLista from "./views/Entrada/MapaEntradaLista";
import EntradaIndividualLista from "./views/Entrada/EntradaIndividualLista";
import ListaRelatorios from "./views/Relatorios/ListaRelatorios";
import GuiaDestinacaoLista from "./views/Saida/GuiaDestinacaoLista";

var routes = [
  {
    path: "/login",
    name: "Login",
    icon: "fas fa-chart-line",
    component: Login,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/trocarsenha",
    name: "TrocarSenha",
    icon: "",
    component: TrocarSenha,
    layout: "/admin",
    sidebar: false
  },
  {
    path: "/home",
    name: "Home",
    icon: "fas fa-home",
    component: () => <div className="content"></div>,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/indicadores",
    name: "Indicadores",
    icon: "fas fa-chart-line",
    component: Dashboard,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/MapaEntrada",
    codigoPermissaoAcesso: "MapaEntrada",
    name: "Mapa de Entrada",
    icon: "fas fa-tasks",
    component: MapaEntradaLista,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/EntradaIndividual",
    codigoPermissaoAcesso: "EntradaIndividual",
    name: "Entrada Individual",
    icon: "fas fa-check-double",
    component: EntradaIndividualLista,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/Destinacao",
    codigoPermissaoAcesso: "Destinacao",
    name: "Destinação",
    icon: "fas fa-truck-loading",
    component: GuiaDestinacaoLista,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/Relatorios",
    codigoPermissaoAcesso: "Relatorios",
    name: "Relatórios",
    icon: "fas fa-file-alt",
    component: ListaRelatorios,
    layout: "/admin",
    sidebar: true
  }
];
export default routes;
